import { useEffect, useState, useContext } from "react";
import React from 'react';
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import globalsettings from "../../../config";
import { useHistory } from "react-router-dom";

import { createStyles, WithStyles, createMuiTheme } from "@material-ui/core/styles";
import {
  create_appointment,
  create_patient,
  remove_reg,
} from "../actions/index";
import {
  GetPaymentToken,
  GetStates,
  postIframedata,
  SaveCard,

} from "../api";
import {
  InsertPELogs,
} from "../api/index";
import { Context, CreditCardPaymentModel, State } from "../store";
import {
  ListItem,
  ListItemIcon,
  IconButton,
  ListItemText,
  Typography,
  CircularProgress,
  TextField,
  Grid,
  Box,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  NativeSelect,
} from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";

// Update log
// FB  7719   02/14/2024  SK  PE- option to add credit card on file while booking an appointment


const styless = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });


export interface DialogTitleProps extends WithStyles<typeof styless> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}


export default function MakePayment() {

  const matches = useMediaQuery("(min-width:600px)");

  const [states, setStates] = useState<State[]>();
  const [statename, setStatename] = useState("");


  const useStyles = makeStyles({
    active: {
      backgroundColor: "#18a2b8",
      color: "white",
      textTransform: "capitalize",
      borderRadius: "15px",
      marginLeft: "20px",
      "&:hover": {
        backgroundColor: "#18a2b8",
      },
    },
    buttonactive: {
      backgroundColor: "#18a2b8",
      color: "white",
      textTransform: "capitalize",
      borderRadius: "15px",
      "&:hover": {
        backgroundColor: "#18a2b8",
      },
      width: "160px",
    },
    inactive: {
      backgroundColor: "white",
      color: "#18a2b8",
      textTransform: "capitalize",
      borderRadius: "15px",
    },
    buttonMargin: {
      marginLeft: "100px",
    },
    datepickerroot: {
      "&.MuiIconButton-root": {
        color: "#18a2b8",
      },
    },
    dropdown_nomargin: {
      "&.MuiFormControl-marginNormal": {
        color: "#18a2b8",
      },
      "& .MuiSvgIcon-root": {
        fontSize: "2rem"
      }
    },
    iconCSS: {
      "& .MuiSvgIcon-root": {
        fontSize: "1.8rem"
      },
      "& .MuiIconButton-root": {
        color: "#18a2b8",
      },
    }
  });

  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
    },
  });

  const classes = useStyles();

  const handleGoBack = () => {
    sessionStorage.setItem("BackFromCreditCardScreen", "True");
    remove_reg(state.slotDetails.id);
    InsertPELogs(globalsettings.clientIp, "Clicked on Go Back - Demographics");
    history.goBack();
  };



  const history = useHistory();
  const [viewIframe, setViewIframe] = useState(true);
  const JSAlert = require("js-alert");

  const styletwo = {
    container: {
      paddingLeft: matches == false ? "16px" : "80px",
      paddingTop: "40px",
      paddingBottom: "40px",
    },
  };
  const stylestart = {
    container: {
      border: "1px grey",
      paddingLeft: matches == false ? "0px" : "55px",

      paddingTop: "10px",
      backgroundColor: "#F8F8F8",
    },
  };
  const [PaymentUrl, setPaymentUrl] = useState("");
  const [sessionId, setSessionId] = useState("");
  const [checked, setChecked] = useState(false);
  const [patientID, setPatientID] = useState("");
  const [emrId, setEmrId] = useState(0);
  const [card, setCardOpen] = useState(false);
  const [paymentToken, setPaymentToken] = useState("");
  const [open, setOpen] = useState(false);
  const { state, dispatch } = useContext(Context);

  const [paymentButton, setPaymentButton] = useState(true);
  const [patientCC, setPatientCC] = useState({} as CreditCardPaymentModel);
  const [saveCardModel, setSaveCardModel] = useState(true);

  const handleChange = async (event: { target: { checked: any } }) => {
    if (event.target.checked) {
      const patObjString = sessionStorage.getItem("patObj");
      if (patObjString !== null) {
        var patObj = JSON.parse(patObjString);
        const values = patObj.PATIENT_CITY_STATE_ZIP.split(', ');

        const [city, stateZip] = values;

        const [state, zip] = stateZip.split(' ');

        setStatename(state);
        setPatientCC({
          ...patientCC,
          firstNameOnCard: patObj.PATIENT_FIRST_NAME,
          lastNameOnCard: patObj.PATIENT_LAST_NAME,
          address: patObj.PATIENT_ADDRESS,
          address2: patObj.PATIENT_ADDRESS2,
          city: city,
          state: state,
          zip: zip,
          phone: patObj.PATIENT_CELL_PHONE,
          email: patObj.PATIENT_EMAIL,
          month: patientCC.month,
          year: patientCC.year,
          CNP: patientCC.CNP,
        });
      }
    }
    else {
      setStatename("");
      setPatientCC({
        ...patientCC,
        firstNameOnCard: "",
        lastNameOnCard: "",
        address: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        phone: "",
        email: "",
      });
    }
  };

  const handleInputChange = (e: any) => {
    if (e.target.name == "PaymentAmount") {
      if (e.target.value > 9999.99) {
        return false;
      }
      let match = /(\d{0,4})[^.]*((?:\.\d{0,2})?)/g.exec(
        e.target.value.replace(/[^\d.]/g, "")
      );
      if (
        match != null &&
        e.target.value > 0 &&
        e.target.value != "" &&
        e.target.value <= 9999.99
      ) {
        setPatientCC({ ...patientCC, ["PaymentAmount"]: match[1] + match[2] });
        setPaymentButton(false);
      } else {
        setPatientCC({ ...patientCC, ["PaymentAmount"]: e.target.value });
        setPaymentButton(true);
      }
    } else {
      setPatientCC({ ...patientCC, [e.target.name]: e.target.value });
      if(e.target.name == "state"){
        setStatename(e.target.value);
      }
    }
  };

  const handleClickOpen = async () => {
    if (!validation()) {
      return;
    }
    var patObjString = sessionStorage.getItem("patObj");

    if (patObjString !== null) {
      var patObj = JSON.parse(patObjString);
    } else {
      var patObj: any = 0;
    }

    var apptObjString = sessionStorage.getItem("appObj");

    if (apptObjString !== null) {
      var appObj = JSON.parse(apptObjString);
    } else {
      var appObj: any = 0;
    }
    let patient_ID;
    if (appObj.PATIENT_N > 0) {
      patient_ID = appObj.PATIENT_N;
      result = await create_appointment(appObj);
      state.patient.name = patObj.PATIENT_FIRST_NAME;
      state.patient.appointment_n = result;
      if (saveCardModel == true) {
        if (
          patientCC.CARD_NAME == null ||
          patientCC.CARD_NAME == undefined ||
          patientCC.CARD_NAME == ""
        ) {
          JSAlert.alert("Please enter Card Name", null, JSAlert.Icons.Warning);
        } else {
          const saveCardData: CreditCardPaymentModel = {
            firstNameOnCard: patientCC.firstNameOnCard,
            lastNameOnCard: patientCC.lastNameOnCard,
            PaymentToken: paymentToken,
            ValidateOrAcceptPayment: "A",
            ExpirationDate: patientCC.month + patientCC.year,
            CNP: patientCC.CNP,
            PaymentAmount: 0,
            address: patientCC.address,
            address2: patientCC.address2,
            city: patientCC.city,
            state: patientCC.state,
            month: patientCC.month,
            year: patientCC.year,
            zip: patientCC.zip,
            phone: patientCC.phone,
            email: state.patientDemographics.email,
            Memo: "",
            Memo2: "",
            FeeAmount: "",
            Patient_N: appObj.PATIENT_N,
            SAVE_CARD: 1,
            CARD_NAME: patientCC.CARD_NAME,
            EMPLOYEE_N: 0,
            COMMENT: "",
            IS_PORTAL_PAYMENT: 0,
          };

          await SaveCard(saveCardData)
        }
      }
      history.push("/confirmationPage", state);
    }
    else {
      var result = await create_patient(patObj, appObj, state.slotDetails.id);
      let patientN = sessionStorage.getItem('patient_n') || '' as "";
      if (patientN != null) {
        patient_ID = patientN;
      }
      if (saveCardModel == true) {
        if (
          patientCC.CARD_NAME == null ||
          patientCC.CARD_NAME == undefined ||
          patientCC.CARD_NAME == ""
        ) {
          JSAlert.alert("Please enter Card Name", null, JSAlert.Icons.Warning);
        } else {
          const values = patObj.PATIENT_CITY_STATE_ZIP.split(', ');
          const saveCardData: CreditCardPaymentModel = {
            firstNameOnCard: patientCC.firstNameOnCard,
            lastNameOnCard: patientCC.lastNameOnCard,
            PaymentToken: paymentToken,
            ValidateOrAcceptPayment: "A",
            ExpirationDate: patientCC.month + patientCC.year,
            CNP: patientCC.CNP,
            PaymentAmount: 0,
            address: patientCC.address,
            address2: patientCC.address2,
            city: patientCC.city,
            state: patientCC.state,
            month: patientCC.month,
            year: patientCC.year,
            zip: patientCC.zip,
            phone: patientCC.phone,
            email: state.patientDemographics.email,
            Memo: "",
            Memo2: "",
            FeeAmount: "",
            Patient_N: appObj.PATIENT_N,
            SAVE_CARD: 1,
            CARD_NAME: patientCC.CARD_NAME,
            EMPLOYEE_N: 0,
            COMMENT: "",
            IS_PORTAL_PAYMENT: 0,
          };

          await SaveCard(saveCardData)
        }
      }
      history.push("/confirmationPage", state);
    }
  };

  function validation() {
    const remonth = /^(0[1-9]|1[012])$/;
    const re = /^[0-9]{5}\-[0-9]{4}$/;
    const rea = /^[0-9]{5}$/;
    const reb = /^[0-9]{9}$/;
    const reyear = /^(?!00)[0-9]{2}$/;
    let isValidZip =
      re.test(patientCC.zip) ||
      reb.test(patientCC.zip) ||
      rea.test(patientCC.zip);
    const currentYearLastTwoDigits = new Date().getFullYear().toString().slice(-2);
    if (saveCardModel == true) {
      if (
        patientCC.CARD_NAME == null ||
        patientCC.CARD_NAME == undefined ||
        patientCC.CARD_NAME == ""
      ) {
        JSAlert.alert("Please enter Card Name", null, JSAlert.Icons.Warning);
        return false;
      }
    }

    if (remonth.test(patientCC.month) == false) {
      JSAlert.alert(
        "Please enter valid month.",
        null,
        JSAlert.Icons.Warning
      );
      return false;
    } else if (patientCC.year < currentYearLastTwoDigits || patientCC.year == null ||
      patientCC.year == undefined ||
      !/^\d+$/.test(patientCC.year) ||
      patientCC.year == "") {
      JSAlert.alert(
        "Please enter valid year",
        null,
        JSAlert.Icons.Warning
      );
      return false;
    }
    else if (patientCC.CNP == "null" || patientCC.CNP?.length < 3 || patientCC.CNP?.length > 4 || patientCC.CNP == undefined) {
      JSAlert.alert(
        "Please enter 3-4 digits CVC number.",
        null,
        JSAlert.Icons.Warning
      );
      return false;
    }
    else if (
      patientCC.firstNameOnCard == null ||
      patientCC.firstNameOnCard == undefined ||
      patientCC.firstNameOnCard == ""
    ) {
      JSAlert.alert(
        "Please Enter Valid First Name.",
        null,
        JSAlert.Icons.Warning
      );
      return false;
    }
    else if (
      patientCC.address == null ||
      patientCC.address == undefined ||
      patientCC.address == ""
    ) {
      JSAlert.alert(
        "Please Enter Valid Address.",
        null,
        JSAlert.Icons.Warning
      );
      return false;
    }
    else if (
      patientCC.city == null ||
      patientCC.city == undefined ||
      patientCC.city == ""
    ) {
      JSAlert.alert(
        "Please Enter Valid City.",
        null,
        JSAlert.Icons.Warning
      );
      return false;
    }
    else if (
      statename == null ||
      statename == undefined ||
      statename == "" ||
      statename == "0"
    ) {
      JSAlert.alert(
        "Please Choose State.",
        null,
        JSAlert.Icons.Warning
      );
      return false;
    }

    else if (
      patientCC.phone == null ||
      patientCC.phone == undefined ||
      patientCC.phone == "" ||
      patientCC.phone.length == 0 ||
      patientCC.phone.length < 10
    ) {
      JSAlert.alert(
        "Please Enter Valid Cell Phone Number (must contain 10 numerics).",
        null,
        JSAlert.Icons.Warning
      );
      return false;
    }
    else if (!isValidZip) {
      JSAlert.alert(
        "Zip code must be 5 or 9 digits or xxxxx-yyyyy",
        null,
        JSAlert.Icons.Warning
      );
      return false;
    }

    return true;
  }

  const handleClose = () => {
    setOpen(false);
    setCardOpen(false);
    setChecked(false);
    setViewIframe(true);
    setIframe({
      index: iframe.index + 1,
    });
    setPaymentUrl("");
    setIsDisabled(true);
    setSessionId("");
    setPaymentToken("");
    handleIframeDetails();
  };
  const [isDisabled, setIsDisabled] = useState(true);
  const [showSpinner, setShowSpinner] = useState(false);


  let patientName = "User";
  let userName: any;
  let EMRID: any;
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    userName = JSON.parse(data).Login;
    EMRID = JSON.parse(data).EMRID;
  }

  async function handleIframeDetails() {

    setShowSpinner(true);
    var data = await postIframedata();
    if (data != null) {
      setPaymentUrl(data.PaymentURL);
      setSessionId(data.SessionID);
      setTimeout(() => {
        setShowSpinner(false);
      }, 10000);
    } else {
      window.location.reload();
    }
    let valueFromSessionStorage = sessionStorage.getItem("PayingAmount");
    if (valueFromSessionStorage) {
      let numberValue = parseFloat(valueFromSessionStorage);
      setPaymentButton(false);
    }
    let totalFromSessionStorage = sessionStorage.getItem("Total");
    if (totalFromSessionStorage) {
      setTotal(totalFromSessionStorage);
    }
  }

  async function getDetails() {
    var data = sessionStorage.getItem("user");
    if (data != null) {
      const user = JSON.parse(data);
      if (user.Patient_n != null) {
        setEmrId(user.EMRID);
        setPatientID(user.Patient_n);
      }
    }
  }

  const [iframe, setIframe] = useState({ index: 0 });

  async function handleChangeCard() {
    setIframe({
      index: iframe.index + 1,
    });
    setPaymentUrl("");
    setIsDisabled(true);
    setSessionId("");
    setPaymentToken("");
    handleIframeDetails();
  }
  async function getStates() {
    var data = await GetStates();
    setStates(data);
  }
  useEffect(() => {
    handleIframeDetails();
    getDetails();
    getStates();
  }, []);
  const Redirect = () => {
    window.location.reload();
  };
  const [ReloadPopUp, setReloadPopup] = useState(false);

  async function iframeVerification() {
    if (paymentToken == "") {
      if (sessionId != "") {
        if (paymentToken == "") {
          var data = await GetPaymentToken(sessionId);
          if (data != null) {
            setPaymentToken(data);
            setIsDisabled(false);
          }
        }
      }
    }
    var res = document.getElementById("iframe");
  }

  const [total, setTotal] = useState("");

  return (
    <div>
      <div className="card" style={stylestart.container}>
        <ListItem>
          <ListItemIcon>
          </ListItemIcon>
          <ListItemText>
            <Typography variant="h5">
              <b>Add Credit Card</b>
            </Typography>
          </ListItemText>
        </ListItem>
      </div>

      <div className="card" style={styletwo.container}>
        <div className="row">
          <div className="col-sm-4">
            <a style={{ textAlign: "left" }}>
              Enter Credit Card Details
              <br />
              {viewIframe && (
                <iframe
                  src={PaymentUrl}
                  key={iframe.index}
                  style={{ height: "70px", border: "none" }}
                  id="iframe"
                  onLoad={iframeVerification}
                  className=""
                />
              )}
            </a>
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "left" }}>
          <Button
            onClick={handleChangeCard}
            variant="contained"
            type="submit"
            style={{ backgroundColor: "#18a2b8", color: "white" }}
          >Change Card Number</Button>
          <br />
        </div>
        <div className="row">
          <div
            className="col-sm-4"
            style={{ paddingBottom: matches == false ? "20px" : "0px" }}
          >
            {matches && <br />}
            {saveCardModel && (
              <TextField
                name="CARD_NAME"
                disabled={isDisabled}
                placeholder="Card Name*"
                onChange={handleInputChange}
                value={patientCC.CARD_NAME}
                label="CARD NAME*"
                id="outlined-size-small"
                size="small"
              />
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-3">
            <p style={{ textAlign: "left" }}>
              *Expiration Date{" "}
              <input
                type="text"
                style={text.container}
                maxLength={2}
                disabled={isDisabled}
                size={2}
                name="month"
                placeholder="MM"
                value={patientCC.month}
                onChange={handleInputChange}
              ></input>
              &nbsp;
              <input
                type="text"
                style={text.container}
                maxLength={2}
                disabled={isDisabled}
                size={2}
                name="year"
                placeholder="YY"
                value={patientCC.year}
                onChange={handleInputChange}
              ></input>
            </p>
          </div>

          <div className="col-sm-4">
            <p style={{ textAlign: "left" }}>
              *CVC{" "}
              <input
                type="text"
                name="CNP"
                style={text.container}
                size={20}
                maxLength={4}
                disabled={isDisabled}
                value={patientCC.CNP}
                onChange={handleInputChange}
              ></input>
            </p>
          </div>
        </div>
        <div className="col-sm-4">
          <p style={{ textAlign: "left" }}>
            <Checkbox
              style={{ width: "20px", height: "30px" }}
              onChange={handleChange}
              disabled={isDisabled}
            />{" "}
            Same As Patient <br />
          </p>
        </div>
        <Grid container spacing={2} style={{ paddingBottom: "20px" }}>
          <Grid item xs={6}>
            <TextField
              label="*First Name"
              id="outlined-size-small"
              size="small"
              type="text"
              disabled={isDisabled}
              name="firstNameOnCard"
              value={patientCC.firstNameOnCard}
              InputLabelProps={{ shrink: true }}
              onChange={handleInputChange}
              style={{
                paddingRight: matches == false ? "0px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Last Name"
              name="lastNameOnCard"
              id="outlined-size-small"
              size="small"
              type="text"
              disabled={isDisabled}
              value={patientCC.lastNameOnCard}
              InputLabelProps={{ shrink: true }}
              onChange={handleInputChange}
              fullWidth
              style={{
                paddingRight: matches == false ? "16px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="*Address"
              id="outlined-size-small"
              size="small"
              type="text"
              disabled={isDisabled}
              name="address"
              value={patientCC.address}
              InputLabelProps={{ shrink: true }}
              onChange={handleInputChange}
              style={{
                paddingRight: matches == false ? "0px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Address2"
              name="address2"
              id="outlined-size-small"
              size="small"
              type="text"
              disabled={isDisabled}
              InputLabelProps={{ shrink: true }}
              value={patientCC.address2}
              onChange={handleInputChange}
              fullWidth
              style={{
                paddingRight: matches == false ? "16px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="*City"
              id="outlined-size-small"
              size="small"
              type="text"
              disabled={isDisabled}
              name="city"
              value={patientCC.city}
              InputLabelProps={{ shrink: true }}
              onChange={handleInputChange}
              style={{
                paddingRight: matches == false ? "0px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <FormControl
              fullWidth
              style={{
                paddingRight: matches == false ? "16px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
              size="small"
            >
              <InputLabel shrink htmlFor="state-native-label-placeholder">
                State *
              </InputLabel>
              <NativeSelect
                className={classes.dropdown_nomargin}
                style={{ width: 250 }}    //FB 4574 DK - Removed px from width
                name="state"
                id="state"
                value={statename}
                onChange={handleInputChange}
                disabled={isDisabled}
                inputProps={{
                  name: "state",
                  id: "states-native-label-placeholder",
                }}
              >
                <option value={0}></option>
                {states?.map((state: State) => (
                  <option value={state.name}>
                    {state.name}
                  </option>
                ))}
              </NativeSelect>


            </FormControl>

          </Grid>
          <Grid item xs={6}>
            <TextField
              label="*Zip Code"
              id="outlined-size-small"
              size="small"
              type="text"
              disabled={isDisabled}
              name="zip"
              InputLabelProps={{ shrink: true }}
              value={patientCC.zip}
              onChange={handleInputChange}
              style={{
                paddingRight: matches == false ? "0px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Email"
              name="email"
              id="outlined-size-small"
              size="small"
              type="text"
              disabled={isDisabled}
              InputLabelProps={{ shrink: true }}
              value={patientCC.email}
              onChange={handleInputChange}
              fullWidth
              style={{
                paddingRight: matches == false ? "16px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="*CellPhone"
              id="outlined-size-small"
              size="small"
              type="text"
              disabled={isDisabled}
              name="phone"
              value={patientCC.phone}
              InputLabelProps={{ shrink: true }}
              onChange={handleInputChange}
              style={{
                paddingRight: matches == false ? "0px" : "24px",
                width: matches == false ? "calc(100% - 5px)" : "calc(100%)",
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          style={{ paddingTop: "10px" }}
        >
          <Grid
            item
            xs={6}
            sm={6}
            md={2}
            lg={2}
          >
            <Button
              onClick={handleClickOpen}
              variant="contained"
              className={classes.active}
              type="submit"
              id="verify"
              style={{ marginLeft: "0" }}
              disabled={isDisabled}
            >Book Appointment</Button>
          </Grid>

          <Grid
            item
            xs={5}
            sm={6}
            md={2}
            lg={2}
          >
            <Button
              onClick={handleGoBack}
              variant="contained"
              id="goBackdemo"
              style={{ marginLeft: "0" }}
              className={classes.active}
            >
              Go Back
            </Button>
          </Grid>
        </Grid>
      </div>

      <div className="col-sm-12">
        <Dialog open={open} onClose={handleClose}>
          <DialogContent>
            <label>Total Balance :&nbsp;${total}</label>
            <hr></hr>
            <label>Enter Payment Amount</label>
            <br></br>
            <TextField
              label="*Payment Amount"
              name="PaymentAmount"
              id="outlined-size-small"
              size="small"
              fullWidth
              style={{ marginTop: "20px" }}
              onChange={handleInputChange}
              autoComplete="off"
            />
            {matches && <br></br>}
            <button
              className="btn"
              style={{
                backgroundColor: "#13607C",
                color: "white",
                marginTop: "10px",
                marginLeft: "15%",
                width: "75px",
              }}

              disabled={paymentButton}
            >
              Pay
            </button>
            &nbsp;&nbsp;&nbsp;
            <button
              className="btn"
              style={button.container}
              onClick={handleClose}
            >
              Cancel
            </button>
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </div>

      <Dialog
        open={ReloadPopUp}
        style={{
          backdropFilter: "blur(3px)",
        }}
        onClose={Redirect}
      >
        <DialogContent style={{ height: "auto" }}>
          <h5 style={{ textAlign: "center" }}>
            Please refresh this page to make payment!
          </h5>
          <br></br>
          <Box textAlign="center">
            <Button
              variant="contained"
              style={{
                backgroundColor: "#13607C",
                color: "white",
              }}
              onClick={Redirect}
            >
              Ok
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <Dialog open={showSpinner} fullWidth maxWidth={"xs"}>
        <DialogContent
          style={{
            display: "flex",
            alignContent: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress style={{ color: "#083A4D" }} />
        </DialogContent>
      </Dialog>
    </div>
  );
}

const button = {
  container: {
    marginTop: "10px",
    width: "75px",
    color: "#13607C",
    backgroundColor: "#F5F5F7",
    borderColor: "#13607C",
  },
};

const text = {
  container: {
    height: "35px",
  },
};

const select1 = {
  container: {
    height: "35px",
    width: "595px",
    borderRadius: "1px",
  },
};

const cards = {
  container: {},
};
